import React, { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { DataGrid } from "@material-ui/data-grid";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";

import Modal from "../../../components/Modal/Modal";
import AddBalanceComponent from "../Create/AddBalanceComponent";

import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";

//Global state Access
import { useAtom } from "jotai";
import { gbState, fYear } from "../../../components/shared/GlobalState";
import BankCardComponent from "./BankCardComponent";
import BalanceView from "./BalanceView";
import toast from "react-hot-toast";

const BalanceListChild = ({ selectedBankId }) => {
  let navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});
  const [data, setData] = useState([]);
  const [showAddBalance, setShowAddBalance] = useState(false);

  const [{ errorLogApi, placeHolderText, user }] = useAtom(gbState);
  const [financial_year] = useState(user?.current_financial_year);
  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const handleDelete = (row) => {
    confirmAlert({
      title: "Confirm Deletion",
      message: "Are you sure you want to delete this bank balance?",
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteRecord(row),
          className: "bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded",
        },
        {
          label: "No",
          className:
            "bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded",
        },
      ],
    });
  };

  const deleteRecord = (row) => {
    let userToken = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${userToken}` },
    };
    axios
      .delete(
        `${process.env.REACT_APP_API_URL}/bank-balance/delete/${row._id}`,
        config
      )
      .then((response) => {
        toast.success("Bank balance deleted successfully");
        getDataFromServer();
      })
      .catch((err) => {
        toast.error("Failed to delete bank balance");
        errorLogApi(err, "BankListChild", "/banks");
      });
  };

  const handleAddBalance = () => {
    // setCurrentRecord(row);
    setShowAddBalance(true);
  };

  const getDataFromServer = () => {
    let userToken = localStorage.getItem("token");

    let urlLink = `${process.env.REACT_APP_API_URL}/bank-balance/${selectedBankId?._id}`;

    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then(function (response) {
        const oldData = response?.data?.bankBalances;
        const filteredData = oldData.filter(
          (bb) => bb.financial_year === financial_year
        );
        const updatedData = filteredData.map((data) => {
          return {
            ...data,
            id: data?._id,
            month: new Date(data?.month)?.toLocaleString("default", {
              month: "long",
              year: "numeric",
            }),
            opening_balance: data?.opening_balance,
            closing_balance: data?.closing_balance,
          };
        });

        setData(updatedData);
      })
      .catch(function (err) {
        toast.error(err?.message || "Failed to fetch bank balances");
        console.log("error api call ", err?.response?.data);
      });
  };

  useEffect(() => {
    getDataFromServer();
  }, []);

  useEffect(() => {
    getDataFromServer();
  }, [financial_year]);

  const columns = [
    {
      field: "Action",
      headerName: "Actions",
      sortable: false,
      hideable: false,
      disableColumnMenu: true,
      width: 120,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="flex flex-row justify-center gap-3">
            <Tooltip title="View details">
              <div
                onClick={() => {
                  toggleModal();
                  setCurrentRecord(params.row);
                }}
                className="p-1 transition-colors duration-200 rounded-full cursor-pointer hover:bg-gray-100"
              >
                <i
                  className="mdi mdi-eye-circle-outline"
                  style={{ fontSize: "18px", color: "#4B5563" }}
                ></i>
              </div>
            </Tooltip>
            {user?.is_a_trustee === true && (
              <Tooltip title="Edit">
                <div
                  onClick={() =>
                    navigate("/balance/update", { state: params.row })
                  }
                  className="p-1 transition-colors duration-200 rounded-full cursor-pointer hover:bg-gray-100"
                >
                  <i
                    className="mdi mdi-square-edit-outline"
                    style={{ fontSize: "18px", color: "#6B7280" }}
                  ></i>
                </div>
              </Tooltip>
            )}
            {user?.is_a_trustee === true && (
              <Tooltip title="Delete">
                <div
                  onClick={() => {
                    handleDelete(params.row);
                  }}
                  className="p-1 transition-colors duration-200 rounded-full cursor-pointer hover:bg-red-50"
                >
                  <i
                    className="mdi mdi-trash-can-outline"
                    style={{ fontSize: "18px", color: "#EF4444" }}
                  ></i>
                </div>
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      field: "month",
      headerName: "Month",
      width: 180,
      headerClassName: "font-semibold",
    },
    {
      field: "opening_balance",
      headerName: "Opening Balance",
      width: 200,
      headerClassName: "font-semibold",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(params.value);
      },
    },
    {
      field: "closing_balance",
      headerName: "Closing Balance",
      width: 200,
      headerClassName: "font-semibold",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(params.value);
      },
    },
    // {
    //   field: "Add Balance",
    //   headerName: "Add Balance",
    //   sortable: false,
    //   hideable: false,
    //   disableColumnMenu: true,
    //   width: 120,
    //   align: "center",
    //   renderCell: (params) => {
    //     return (
    //       <div>
    //         <button onClick={() => handleAddBalance(params.row)}>
    //           Add Balance
    //         </button>
    //       </div>
    //     );
    //   },
    // },
  ];

  return (
    <div
      className="w-full p-6 bg-white rounded-lg shadow-sm"
      style={{ wordBreak: "break-word" }}
    >
      <div className="flex flex-col space-y-6">
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-bold text-gray-800">
            Bank Balance List
          </h2>
          {/* <button
            className="flex items-center gap-2 px-4 py-2 text-white transition-colors duration-200 bg-blue-600 rounded-md hover:bg-blue-700"
            onClick={() => handleAddBalance()}
          >
            Add / Update Balance
          </button> */}

          {user?.is_a_trustee === true && (
            <button
              className="flex items-center gap-2 px-4 py-2 text-white transition-colors duration-200 bg-blue-600 rounded-md hover:bg-blue-700"
              onClick={() =>
                navigate("/balance/add", { state: selectedBankId })
              }
            >
              <i className="text-lg mdi mdi-plus"></i>
              Add Balance
            </button>
          )}
        </div>

        <div className="p-4 rounded-lg bg-gray-50">
          <BankCardComponent data={selectedBankId} />
        </div>

        <ErrorBoundaryRoutes route="/banks" page="ModalView">
          {showModal && (
            <Modal onClose={toggleModal}>
              <div className="p-4">
                <h2 className="mb-4 text-xl font-bold text-gray-800">
                  Bank Balance Detail
                </h2>
                <BalanceView currentRecord={currentRecord} />
              </div>
            </Modal>
          )}
        </ErrorBoundaryRoutes>

        {showAddBalance && (
          <Modal onClose={() => setShowAddBalance(false)}>
            <AddBalanceComponent
              currentRecord={currentRecord}
              selectedBank={selectedBankId}
              refreshDataFromServer={getDataFromServer}
              setShowAddBalance={setShowAddBalance}
            />
          </Modal>
        )}

        <div className="mt-4 bg-white border border-gray-200 rounded-lg">
          <DataGrid
            rows={data}
            disableSelectionOnClick
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            displayTitle="Banks"
            checkboxSelection
            style={{ height: "60vh" }}
            className="border-0"
            headerHeight={50}
            rowHeight={50}
          />
        </div>
      </div>
    </div>
  );
};

export default BalanceListChild;
